module.exports = __webpack_public_path__ + "static/Geesche-Martin-a3b73c195215478dcae3a0ed24f46463.jpg";